import { useParams } from 'react-router-dom'
import InnerClientSplash from './innerClientSplash'
import InnerClientGallery from './innerClientGallery'
import TemplateMain from '../templateMain'

// TO DO Shouldn't this page be titles index.tsx to be consistent
export default function PagePortfolio() {
  const { client, type } = useParams()
  return (
    <TemplateMain
      g_section="portfolio"
      htmlTitle="Portfolio"
      linksTitle="Other Links"
      innerPage={
        type === 'splash' ? (
          <InnerClientSplash client={client as string} />
        ) : (
          <InnerClientGallery client={client as string} />
        )
      }
      g_sidebarKey={`pageClient_${client}`}
      g_slideshowKey="projects"
    />
  )
}
